/* eslint-disable camelcase */
export const fetchUriMock: { resource: { uri: string; current_organization: string } } = {
  resource: {
    uri: 'https://api.calendly.com/users/AAAAAAAAAAAAAAAA',
    current_organization: 'https://api.calendly.com/organizations/AAAAAAAAAAAAAAAA',
  },
};

export const fetchDataMock: {
  collection: [{ start_time: string; end_time: string }];
} = {
  collection: [
    { start_time: '2019-08-24T14:15:22.123456Z', end_time: '2019-08-24T14:45:22.123456Z' },
  ],
};
/* eslint-enable camelcase */
